import React from 'react';
import { Navbar, Nav, Container, Form, Col, Row, Button, Modal, Image, Spinner} from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Link } from 'react-router-dom';
import { Constants } from "../../constants";
import GuestSiteMenu from "../guest_menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class ContractorRegister extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            value: '',
            loading: false,
            error: null,
            showModal: false
        };

        this.feedback = this.feedback.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.showButton = this.showButton.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleContractorSubmit = this.handleContractorSubmit.bind(this);
        this.handleContractorPin = this.handleContractorPin.bind(this);
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true });
        axios.post(`${Constants.apiURL}/api/Identity/Login`, {
            email: this.state.email,
            password: this.state.password
        }).then(response => {
            if (response.data && response.data.message) {
                if (response.data.message.succeeded == true) {
                    this.setState({
                        showModal: true,
                        loading: false,
                        user:response.data.user
                    });
                }
                else {
                    this.setState({ error: 'Invalid email or password' });
                }
            }
            else {
                this.setState({ error: 'Invalid email or password' });
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ error: 'Error connecting to server.' })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    showButton() {
        if (this.state.loading) {
            return <div>
                <Button style={{ marginTop: '5px', backgroundColor: '#1F419B', width: '80px' }} variant="primary" type="submit" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true" />
                    <span className="visually-hidden">Loading...</span>
                </Button>
                <br />
                <p style={{ fontSize: '14px', paddingTop: '5px', marginBottom: '0px' }}>Trouble logging in? Contact us at&nbsp;
                    <Link
                        to='#'
                        onClick={(e) => {
                            window.location.href = 'mailto:clientportal@boland.com';
                            e.preventDefault();
                        }}
                    >clientportal@boland.com</Link></p>
                <Link to={{
                    pathname: "/forgot_password"
                }} style={{ marginTop: '0px' }}>Forgot password?</Link>
                <p style={{ fontSize: '14px', paddingTop: '10px' }}>Don’t have a portal account yet? Click below to register.</p>
                <Button style={{ marginTop: '-10px', width: '80px', backgroundColor: '#00973A' }} type="button" onClick={this.handleRegister}>
                        Register
             </Button></div>
        }
        else {
            return <div><Button style={{ marginTop: '10px', backgroundColor: '#1F419B', width: '80px' }} variant="primary" type="submit">
                Login
            </Button>
                <br />
                <p style={{ fontSize: '14px', paddingTop: '5px', marginBottom: '0px' }}>Trouble logging in? Contact us at&nbsp;
                    <Link
                        to='#'
                        onClick={(e) => {
                            window.location.href = 'mailto:clientportal@boland.com';
                            e.preventDefault();
                        }}
                    >clientportal@boland.com</Link></p>
                <Link to={{
                    pathname: "/forgot_password"
                }} style={{ marginTop: '0px' }}>Forgot password?</Link>
                <p style={{ fontSize: '14px', paddingTop: '10px' }}>Don’t have a portal account yet? Click below to register.</p>
                <Button style={{ marginTop: '-10px', width: '80px', backgroundColor: '#00973A' }} type="button" onClick={this.handleRegister}>
                    Register
                </Button></div>
        }
    }

    handleRegister(event) {
        event.preventDefault();
        this.props.history.push({
            pathname: '/contractor_register'
        });
    }
    handleContractorPin(event) {
        this.setState({
            contractorPin: event.target.value
        });
    }
    handleContractorSubmit() {
        axios.get(`${Constants.apiURL}/api/Identity/LoginContractor`, {
            params: {
                username: this.state.user.username,
                contractorPin: this.state.contractorPin
            }
        }).then(response => {
            if (response.data) {
                this.setState({ showModal: false });

                ReactGA.event({
                    category: 'Login',
                    action: 'Contractor Login',
                    label: 'Contractor Login'
                });
                this.props.history.push({
                    pathname: "/contractor_portal",
                    state: {
                        user: this.state.user,
                        contractor: response.data
                    }
                });
            }
            else {
                alert('Invalid access code.');
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }
    handleClose() {
        this.setState({ showModal: false });
    }

    feedback() {

        this.props.history.push({
            pathname: "/feedback",
            state: {
                previousPage: this.state.currentPage
            }
        });
    }
    render() {
        const customStyle = {
            padding: '10px',
            margin: '10px',
            maxWidth: '480px'
        };

        const showModal = this.state.showModal;

        return (
            <div onSubmit={this.handleSubmit}>
                <Navbar className="boland-navbar" collapseOnSelect expand="md" defaultExpanded={false} sticky="top" style={{paddingTop:'3px', paddingBottom:'3px'}}>
                    <Container style={{ marginLeft: '0px', paddingRight: 0, maxWidth: '100%' }}>
                        <Navbar.Brand as={Link} to={{
                            pathname: "/contractor_portal",
                            state: {
                                user: this.state.user,
                                contrator: this.state.contractor
                            }
                        }}>
                            <Image src="./Boland block 2.png" width="165px" height="40px" />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="ml-auto" style={{ width: '100%' }}>

                                <div style={{ width: '100%' }} />
                                <Button size="sm" className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#EF4139', minWidth: 'max-content' }} onClick={this.feedback}>
                                    Feedback? Let us know here.
                                </Button>
                                <Nav.Link href="https://www.boland.com/training-events" target="_blank">Training</Nav.Link>
                                <Nav.Link href="https://www.boland.com/news" target="_blank">News</Nav.Link>
                                <Button className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#1F419B' }} onClick={() => {

                                    this.props.history.push({
                                        pathname: "/contractor_login"
                                    });
                                }}>
                                    Login/Register
                                </Button>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <Modal show={showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton style={{ backgroundColor: '#1F419B', color: '#FFFFFF' }}>
                        <Modal.Title>Contractor Portal Login</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Enter your contractor access code:</Form.Label>
                                <Form.Control autoFocus onChange={this.handleContractorPin} maxLength="20" />
                            </Form.Group>
                            <Form.Label style={{ fontStyle: 'italic' }}>Not sure of your access code?<br />Please contact your Boland salesperson</Form.Label>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'flex-start' }}>
                        <Button variant="primary" name="confirm" onClick={this.handleContractorSubmit} style={{ backgroundColor: '#1F419B' }}>
                            Submit
                        </Button>
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Form style={customStyle} onSubmit={this.handleSubmit} noValidate>
                    <Form.Label style={{ verticalAlign: 'middle', fontWeight: 'bold', fontSize: '26px', color: '#1F419B' }}>Contractor Portal Login</Form.Label>
                    <Form.Label style={{ verticalAlign: 'middle', fontStyle: 'italic', fontSize: '21px', color: '#1F419B' }}>Looking for our Client Portal?&nbsp;<Link to={{
                        pathname: "/"
                    }} style={{ marginTop: '10px' }}>Click here.</Link></Form.Label>
                    <Row>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" onChange={this.handleEmailChange}
                                    isInvalid={!!this.state.error} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder="Password" onChange={this.handlePasswordChange}
                                    isInvalid={!!this.state.error} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.error}
                                </Form.Control.Feedback>
                            </Form.Group>
                            {this.showButton()}
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

export default ContractorRegister;